import { NavigateOptions } from "react-router-dom";
import { router } from "../routes";
import { FaFilePdf } from "react-icons/fa";

export function classNames(...classes: (string | boolean)[]) {
  return classes.filter(Boolean).join(" ");
}

const { REACT_APP_S3PUBLIC_URL: S3PUBLIC_URL } = process.env;

export function navigateTo(props: string = "", options: NavigateOptions = {}) {
  return router.navigate(props?.[0] === "/" ? props : `/${props}`, options);
}

export const YesNoToBoolean = (val: string): boolean =>
  String(val).toLowerCase() === "yes";

export const BooleanToYesNo = (val: boolean): string =>
  Boolean(val) ? "Yes" : "No";

export const getPreSignedUrl = ({ claimId, fileName }) => {
  return `${S3PUBLIC_URL}/claims_documentation/CL-${claimId}/photos-consumer/${fileName}`;
};

export function checkAllKeysHaveValue(obj) {
  if (Array.isArray(obj)) {
    return obj.every((item) => checkAllKeysHaveValue(item));
  } else if (typeof obj === "object" && obj !== null) {
    return Object.values(obj).every((value) => checkAllKeysHaveValue(value));
  } else {
    obj ??= "";
    return obj.toString().length > 0;
  }
}

export const formatCurrency = (value: number) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(value);
};

export const renderPDFImage = (url) => {
  const fileName = url?.split("/")?.pop();
  const extension = fileName?.substring(fileName.lastIndexOf(".") + 1);
  const ISPDF = extension?.toLowerCase() === "pdf";
  if (!url) return null;
  return ISPDF ? (
    <FaFilePdf className="size-12 object-cover mr-2" />
  ) : (
    <div className="flex items-center gap-4 mt-1">
      <img
        src={url}
        alt=""
        className="size-16 bg-gray-100 rounded-md cursor-pointer object-cover"
      />
    </div>
  );
};
